import gql from 'graphql-tag'

export default gql`
  query searchItemPagination(
    $keyword: String
    $pageNumber: Int!
    $itemPerPage: Int!
    $itemReceivingKindIds: [Int!]
    $sortKey: String
    $sceneIds: [Int!]
    $categoryIds: [Int!]
    $stringLowerBudget: String
    $stringHigherBudget: String
  ) {
    searchItems(
      keyword: $keyword
      pageNumber: $pageNumber
      itemPerPage: $itemPerPage
      itemReceivingKindIds: $itemReceivingKindIds
      sortKey: $sortKey
      sceneIds: $sceneIds
      categoryIds: $categoryIds
      stringLowerBudget: $stringLowerBudget
      stringHigherBudget: $stringHigherBudget
    ) {
      pagination {
        currentPage
        totalPages
        totalCount
      }
    }
  }
`
